module.exports = __webpack_public_path__ + "static/media/OnlineDiary.c230775f.jpeg";